import { instance } from "./interceptor";
import * as Sentry from "@sentry/react";

export async function uploadImage(formData: FormData): Promise<string | null> {
  try {
    const res = await instance.post(`/uploads/image/workspace/logo`, formData);
    return res.data.logo;
  } catch (error) {
    Sentry.captureException(error, {
      extra: { formData: formData },
    });
    return null;
  }
}

export async function uploadImage2(formData: FormData): Promise<string | null> {
  try {
    const res = await instance.post(`/uploads/image`, formData);
    return res.data.result;
  } catch (error) {
    return null;
  }
}

//INFO: (new) 이미지 업로드 API
export async function uploadImageToS3(formData: FormData): Promise<string | null> {
  try {
    const res = await instance.post(`/uploads/image`, formData);
    return res.data.result;
  } catch (error) {
    return null;
  }
}

export const uploadUserProfileImage = async (formData: FormData): Promise<string | null> => {
  try {
    const res = await instance.post("/uploads/image/user/picture", formData);
    return res.data.picture;
  } catch (error) {
    Sentry.captureException(error, {
      extra: { formData: formData },
    });
    return null;
  }
};
